import { render } from "./Suplementos.vue?vue&type=template&id=15e8d655&scoped=true"
import script from "./Suplementos.vue?vue&type=script&lang=js"
export * from "./Suplementos.vue?vue&type=script&lang=js"

import "./Suplementos.vue?vue&type=style&index=0&id=15e8d655&lang=scss&scoped=true"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15e8d655"]])

export default __exports__